/**
 * 域名口径的单一来源(OEM 域名方案 7.2,0930 拍板)。
 *
 * ★直营白名单是**显式列表**,不再用 `*.xbwhynot.com` 通配:渠道后台落在我方主域的子区
 *   `{code}.oem.xbwhynot.com`(生产)/ `{code}.oem-demo.xbwhynot.com`(演示),通配会让渠道子域
 *   首屏闪「销帮」并把 DEFAULT 缓存下来。
 * ★与后端 PARTNER_SYSTEM_HOSTS 同源(各环境显式列举);后端未知 Host 仍按 system,所以白名单外的
 *   域名只是「等接口」,不是「拒绝」。
 */

/** 渠道子区后缀:命中即一律不算直营,必须等 /public/brand。 */
export const PARTNER_SUBZONE_SUFFIXES = [".oem.xbwhynot.com", ".oem-demo.xbwhynot.com"] as const;

/** 直营显式白名单(主机名,小写)。裸 IPv4 另按正则判。 */
export const DIRECT_HOSTS: readonly string[] = [
  "gscq.xbwhynot.com",
  "demo.xbwhynot.com",
  "test.gscq.xbwhynot.com",
  "localhost",
  "127.0.0.1",
  "::1",
  "[::1]",
];

const IPV4_RE = /^\d{1,3}(\.\d{1,3}){3}$/;

export function normalizeHost(hostname: string): string {
  return hostname.trim().toLowerCase().replace(/\.$/, "");
}

/** 是不是渠道子区下的域名(`{code}.oem.xbwhynot.com` / `{code}.oem-demo.xbwhynot.com`)。 */
export function isPartnerSubzoneHost(hostname: string): boolean {
  const h = normalizeHost(hostname);
  return PARTNER_SUBZONE_SUFFIXES.some((s) => h.endsWith(s) && h.length > s.length);
}

/** 是否在直营显式白名单内(含裸 IPv4)。不看私有化开关 —— 由调用方处理。 */
export function isListedDirectHost(hostname: string): boolean {
  const h = normalizeHost(hostname);
  if (isPartnerSubzoneHost(h)) return false;
  if (DIRECT_HOSTS.includes(h)) return true;
  // 裸 IPv4(测试机/演示机直连):渠道不会拿 IP 当对客域名。
  return IPV4_RE.test(h);
}
